<template>
  <div class="ps">
    <div class="head-list">
      <div v-for="(item, index) in headList" :key="index">
        <div class="num">{{item.value}}</div>
        <div class="text">{{item.name}}{{item.unit}}</div>
      </div>
    </div>
    <div class="line1">
      <div class="content-left w-30" v-if="summary">
        <div class="item">
          <div class="text">配送中</div>
          <div class="num">{{summary.deliveryIngTimes}} <span class="unit">次</span></div>
          <el-progress :width="60" type="circle" :percentage="parseInt(summary.deliveryIngTimesRate || 0)"></el-progress>
        </div>
        <div class="item">
          <div class="text">配送中商品金额</div>
          <div class="num">{{summary.deliveryIngProductAmount}}  <span class="unit">单</span></div>
          <el-progress :width="60" type="circle" color="orange" :percentage="parseInt(summary.deliveryIngProductAmountRate || 0)"></el-progress>
        </div>
        <div class="item">
          <div class="text">配送中商品数量</div>
          <div class="num">{{summary.deliveryIngProductQuantity}} <span class="unit">件</span></div>
          <el-progress :width="60" type="circle" color="green" :percentage="parseInt(summary.deliveryIngProductQuantityRate || 0)"></el-progress>
        </div>
        <div class="item">
          <div class="text">待支付费用</div>
          <div class="num">{{summary.deliveryFee}} <span class="unit">元</span></div>
          <el-progress :width="60" type="circle" color="blue" :percentage="parseInt(summary.feesPayRate || 0)"></el-progress>
        </div>
      </div>
      <div class="content w-70">
        <div class="top"><div class="icon"></div>月统计</div>
        <div id="ps-charts1"></div>
      </div>
    </div>
    <div class="line1">
      <div class="content w-50" style="margin-right:20px">
        <div class="top"><div class="icon"></div>平台配送费</div>
        <div id="ps-charts2"></div>
      </div>
      <div class="content w-50">
        <div class="top"><div class="icon"></div>配送国家排行</div>
        <!-- <div class="title">
          <div>销售总金额：1000万</div>
          <div>订单笔数：10000单</div>
        </div> -->
        <div id="ps-charts3"></div>
      </div>
    </div>
    <div class="line1">
      <div class="content w-100">
        <div class="top"><div class="icon"></div>配送明细</div>
        <div>
          <div class='ux-tabs tabs' style="margin:0 40px;
            width:calc(100% - 80px);margin-top:16px;min-height:100px">
            <div class="ux-filter-records filter-records">
              <div class='content-list' style="height:auto">
                <el-table
                  class="table ux-dark-el-table"
                  :data="tableData1"
                  max-height="360"
                  empty-text="暂无数据"
                  element-loading-spinner="el-icon-loading">
                    <el-table-column v-for="(props, i) in tableHeader1" :label='props.label' align="center" :key="i" show-overflow-tooltip>
                      <template slot-scope="scope">
                        <div v-if="props.type">
                          {{scope.$index + 1}}
                        </div>
                        <div v-else class="text">{{ scope.row[props.prop] }}</div>
                      </template>
                    </el-table-column>
                </el-table>
              </div>
              <div class='pages'>
                <span>共 {{ page1.total }} 条数据</span>
                <el-pagination
                  class="ux-dark-el-pagination"
                  small
                  background
                  layout="prev, pager, next"
                  :current-page="page1.current"
                  :page-size="page1.size"
                  :total="page1.total"
                  @current-change="currentChange1"
                />
                <pagination @currentChange="currentChange1" @sizeChange="sizeChange1"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import common from '@/utils/common'
// import languageObj from '@/utils/lan.json'
import apiPath from '@config/api.json'
import pagination from '@/components/main/bigData/home/compontents/pagination.vue'
import { Loading } from 'element-ui'
const {mapState, mapMutations} = require('vuex')
export default {
  components: { pagination },
  props: ['info'],
  data () {
    return {
      tableHeader1: [
        {
          type: 'index',
          label: '序号'
        },
        {
          prop: 'orderNo',
          label: '订单编号'
        },
        {
          prop: 'deliveryDate',
          label: '配送日期'
        },
        {
          prop: 'carrier',
          label: '承运人'
        },
        {
          prop: 'waybillNo',
          label: '运单号'
        },
        {
          prop: 'shipper',
          label: '发货人'
        },
        {
          prop: 'shippingAddress',
          label: '发货地址'
        },
        {
          prop: 'receiveer',
          label: '收货人'
        },
        {
          prop: 'receivingAddress',
          label: '收货地址'
        },
        {
          prop: 'productName',
          label: '商品名称'
        },
        {
          prop: 'productQuantity',
          label: '商品数（件）'
        },
        {
          prop: 'shippingPrice',
          label: '配送费用（元）'
        },
        {
          prop: 'receiveDate',
          label: '签收日期'
        }
      ],
      tableData1: [],
      headList: [],
      page1: {
        current: 1,
        size: 10,
        total: 0
      },
      summary: {},
      topCountryShippingQuantitySummarySummary: {},
      topShippingMonthSummary: {},
      topSourceShippingFeeSummary: {}
    }
  },

  computed: {
    ...mapState({
      searchDate: (state) => {
        return state.home.searchDate
      }
    })
  },

  watch: {
    searchDate: function (n) {
      this.init()
    }
  },

  created () {
  },

  mounted () {
    this.init()
  },

  methods: {
    ...mapMutations({}),
    init () {
      this.getInfo()
      this.getMonthStatistics()
      this.getList()
    },
    getInfo () {
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.getShippingOrderStatistics}`,
        data: {
          'companyName': this.info.companyName,
          'pageIndex': this.page1.current,
          'pageSize': this.page1.size,
          'searchDate': this.searchDate,
          'searchParam': '',
          'sortParam': '',
          'yearTime': this.searchDate
        }
      }).then(res => {
        this.summary = res.data.summary
        this.topCountryShippingQuantitySummarySummary = res.data.topCountryShippingQuantitySummarySummary
        this.topShippingMonthSummary = res.data.topShippingMonthSummary
        this.topSourceShippingFeeSummary = res.data.topSourceShippingFeeSummary
        let that = this
        this.headList = [
          {
            name: '运单数',
            value: that.summary.waybillsQuantity || '0',
            unit: '（单）'
          }, {
            name: '配送次数',
            value: that.summary.deliveryTimes || '0',
            unit: '（次）'
          }, {
            name: '配送费用',
            value: that.summary.feesPay || '0',
            unit: '（元）'
          }, {
            name: '配送商品金额',
            value: that.summary.deliveredProductAmount || '0',
            unit: '（元）'
          }, {
            name: '配送商品数',
            value: that.summary.deliveredProductQuantity || '0',
            unit: '（个）'
          }, {
            name: '配送商品件数',
            value: that.summary.deliveredProductQuantity || '0',
            unit: '（件）'
          }
        ]
        // this.initCharts1()
        this.initCharts2()
        this.initCharts3()
      })
    },
    getMonthStatistics () {
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.getShippingMonthStatistics}`,
        data: {
          'companyName': this.info.companyName,
          'pageIndex': this.page1.current,
          'pageSize': this.page1.size,
          'searchDate': this.searchDate,
          'searchParam': '',
          'sortParam': '',
          'yearTime': this.searchDate
        }
      }).then(res => {
        this.topShippingMonthSummary = res.data.topShippingMonthSummary // 运单数
        this.topDeliveryFeeMonthSummary = res.data.topDeliveryFeeMonthSummary // 配送费
        this.initCharts1()
      })
    },
    getList () {
      const loadTips = Loading.service()
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.listShippingOrder}`,
        data: {
          'companyName': this.info.companyName,
          'pageIndex': this.page1.current,
          'pageSize': this.page1.size,
          'searchDate': this.searchDate
        }
      }).then(res => {
        loadTips.close()
        this.page1.total = res.total
        this.tableData1 = res.data
      })
    },
    currentChange1 (e) {
      this.page1.current = e
      this.getList()
    },
    sizeChange1 (e) {
      this.page1.current = 1
      this.page1.size = e
      this.getList()
    },
    initCharts1 () {
      let monthTime = this.topShippingMonthSummary.map(item => { return item.monthTime })
      let deliveryFee = this.topShippingMonthSummary.map(item => { return item.deliveryFee })
      let waybillsQuantity = this.topDeliveryFeeMonthSummary.map(item => { return item.waybillsQuantity })
      let data = ['运单数', '配送费']
      var chartDom = document.getElementById('ps-charts1')
      var myChart = this.$echarts.init(chartDom)
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        grid: {
          top: '10%',
          left: '2%',
          right: '2%',
          bottom: '0%',
          containLabel: true
        },
        legend: {
          data: data,
          textStyle: {
            color: '#fff'
          }
        },
        xAxis: [
          {
            type: 'category',
            data: monthTime,
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: {
              textStyle: {
                color: '#fff'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: data[0]
            // min: 0,
            // max: 250,
            // interval: 50,
            // axisLabel: {
            //   formatter: '{value}',
            //   textStyle: {
            //     color: '#fff'
            //   }
            // }
          },
          {
            type: 'value',
            name: data[1]
            // min: 0,
            // max: 25,
            // interval: 5,
            // axisLabel: {
            //   formatter: '{value} ',
            //   textStyle: {
            //     color: '#fff'
            //   }
            // }
          }
        ],
        series: [
          {
            name: data[0],
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value
              }
            },
            barWidth: 16,
            data: waybillsQuantity
          },
          {
            name: data[1],
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value
              }
            },
            data: deliveryFee
          }
        ]
      }
      option && myChart.setOption(option)
    },
    initCharts2 () {
      let data = []
      for (let item of this.topSourceShippingFeeSummary) {
        data.push({
          name: item.sysSource,
          value: Number(item.deliveryFee) || 0,
          deliveryFee: item.deliveryFee,
          deliveryFeeRate: item.deliveryFeeRate,
          sysSource: item.sysSource,
          waybillsQuantity: item.waybillsQuantity
        })
      }
      var chartDom = document.getElementById('ps-charts2')
      var myChart = this.$echarts.init(chartDom)
      let option
      option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          right: 'right',
          textStyle: {
            color: '#fff'
          }
        },
        label: {
          alignTo: 'edge',
          formatter: '{name|{c}}\n{d}% {time|{b}}',
          minMargin: 5,
          edgeDistance: 10,
          lineHeight: 15,
          rich: {
            // time: {
            //   fontSize: 10,
            //   color: '#999'
            // },
            // name: {
            //   fontSize: 10,
            //   color: '#999'
            // }
          }
        },
        series: [
          {
            name: '平台配送费',
            type: 'pie',
            radius: ['50%', '80%'],
            center: ['40%', '42%'],
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      option && myChart.setOption(option)
    },
    initCharts3 () {
      let data = []
      for (let item of this.topCountryShippingQuantitySummarySummary) {
        data.push({
          name: item.country,
          value: Number(item.deliveryFee) || 0,
          deliveryFee: item.deliveryFee,
          deliveryFeeRate: item.deliveryFeeRate,
          country: item.country,
          waybillsQuantity: item.waybillsQuantity
        })
      }
      var chartDom = document.getElementById('ps-charts3')
      var myChart = this.$echarts.init(chartDom)
      let option
      option = {
        tooltip: {
          trigger: 'item'
        },
        label: {
          alignTo: 'edge',
          formatter: '{name|{c}}\n{d}% {time|{b}}',
          minMargin: 5,
          edgeDistance: 10,
          lineHeight: 15,
          rich: {
            // time: {
            //   fontSize: 10,
            //   color: '#999'
            // },
            // name: {
            //   fontSize: 10,
            //   color: '#999'
            // }
          }
        },
        legend: {
          orient: 'vertical',
          right: 'right',
          textStyle: {
            color: '#fff'
          }
        },
        series: [
          {
            name: '配送国家',
            type: 'pie',
            radius: ['50%', '80%'],
            center: ['40%', '42%'],
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      option && myChart.setOption(option)
    }
  }
}
</script>

<style lang="scss" scoped>
  .ps{
    .head-list{
      display: flex;
      margin-top: 30px;
      margin-bottom: 24px;
      justify-content: space-between;
      padding: 0 150px;
      color:#fff;
      font-size:24px;
      .num{
        color: rgb(71,166,234);
        font-size:24px;
        line-height: 40px;
        text-align: center;
      }
      .text{
        font-size:18px;
        line-height: 24px;
      }
    }
    .content-left{
      margin-top:32px;
      .item{
        display: flex;
        align-items: center;
        justify-content: space-around;
        height:96px;
        font-size: 14px;
        margin-bottom: 32px;
        border: 1px solid rgb(71,166,234);
        border-radius: 6px;
        padding: 0 20px 0 20px;
        .text{
          width: 100px;
          text-align: left;
        }
        .num{
          font-size:18px;
          width: 100px;
        }
        .unit{
          color: rgb(71,166,234);
          font-size:16px
        }
      }
    }
    .content{
      border: 1px solid rgb(71,166,234);
      border-radius: 6px;
      padding: 16px 20px 32px 20px;
      margin:32px 0 16px 0;
      .top{
        display: flex;
        font-size:18px;
        .icon{
          width: 20px;
          height: 20px;
          border-radius: 4px;
          background: rgb(71,166,234);
          margin-right:16px;
        }
      }
      .title{
        text-align: center;
        display: flex;
        justify-content: space-around;
        padding: 0 100px;
        font-size:18px;
      }
    }
    .line1{
      display: flex;
      height: 440px;
      margin-bottom:72px;
      margin-left:30px;
    }
    .line2{
      display: flex;
      height: 800px;
      margin-bottom:65px;
      margin-left:30px;
    }
    .w-70{
      width: 1050px;
      height: 100%;
      // margin-right:20px;
      // margin-left:32px;
    }
    .w-30{
      width: 710px;
      height: 100%;
      margin-left:0;
      margin-right:20px;
    }
    .w-100{
      width: calc(100% - 70px);
      height: 100%;
      // margin-right:32px;
      // margin-left:32px;
    }
    .w-50{
      width: 880px;
      height: 100%;
      // margin-right:32px;
      // margin-left:32px;
    }
    #ps-charts1{
      margin-top:8px;
      width: 100%;
      height: 400px;
    }
    #ps-charts2{
      margin-top:60px;
      width: 100%;
      height: 400px;
    }
    #ps-charts3{
      margin-top:60px;
      width: 100%;
      height: 400px;
    }
  }
</style>
<style lang="scss">
  .el-progress__text{
      color:#fff !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/search/compontents/ps.vue